export const getBreakpointValue = (breakpoint) => {
    const breakpointValue = getComputedStyle(document.body).getPropertyValue(`--breakpoint-${breakpoint}`)
    return breakpointValue ? Number(breakpointValue.replace('px', '')) : undefined
}

const parseUpperBookingDate = (timeInMs) => {
    const date = new Date()
    date.setTime(timeInMs)

    const year = date.getUTCFullYear()
    const month = date.getUTCMonth() + 1
    const day = date.getUTCDate()

    return `${year}-${month / 10 < 1 ? '0' + month : month}-${day / 10 < 1 ? '0' + day : day}`
}

const WEEK_IN_MILISECONDS = 7 * 24 * 60 * 60 * 1000

export const getDefaultUpperBookingChackinDates = () => {
    const date = new Date()
    const currentTime = date.getTime()

    const parsedCurrentDate = parseUpperBookingDate(currentTime)
    const dateWeekAheadInMs = WEEK_IN_MILISECONDS + currentTime
    const parsedWeekAheadDate = parseUpperBookingDate(dateWeekAheadInMs)

    return {
        checkin: parsedCurrentDate,
        checkout: parsedWeekAheadDate
    }
}
